import React from 'react';
import Footer from '../../components/Shared/Footer';
import HomeHeader from '../Home/Home/HomeHeader/HomeHeader';
import BlogTwoArea from './BlogTwoArea/BlogTwoArea';

const BlogTwoColumn = () => {
    return (
        <>
            <HomeHeader/>
            <BlogTwoArea/>
            <Footer/>
        </>
    );
};

export default BlogTwoColumn;